<template>
  <div class="graphics container">
    <div class="head-data">
      <h6 class="title">{{ title }} {{ selectedYear }}</h6>
    </div>
    <canvas class="canvas" :id="idGraphic"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

export default {
  name: "PlanetChart",
  data() {
    return {
      img: "",
      myChart: null,
    };
  },
  props: ["titles", "data", "idGraphic", "title", "selectedYear"],
  watch: {
    data: function() {
      this.grafica();
    },
  },
  methods: {
    grafica: function() {
      var ctx = document.getElementById(this.idGraphic).getContext("2d");
      if (this.myChart != null) {
        this.myChart.destroy();
      }
      this.myChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.data[0],
          datasets: [
            {
              label: this.titles[0],
              data: this.data[1],
              backgroundColor: ["#770baa"],
              borderColor: ["#770baa"],
              barThickness: 40,
            },
            {
              label: this.titles[1] ?? "Datos no Encontrados",
              data: this.data[2],
              backgroundColor: ["#2ecc71"],
              borderColor: ["#2ecc71"],
              barThickness: 40,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: "Presupuesto (CLP)",
                font: {
                  weight: "bold",
                },
              },
            },
            x: {
              title: {
                display: true,
                text: "Resultado",
                font: {
                  weight: "bold",
                },
              },
              grid: {
                display: false,
              },
            },
          },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
            },
          },
        },
      });
    },
  },
  mounted() {
    this.grafica();
  },
};
</script>

<style scoped>
.canvas {
  font-size: 14px;
  color: #052333;
  padding-bottom: 2rem;
  padding: 1rem 3rem;
}
.graphics {
  padding-bottom: 2rem;
  padding: 1rem 5rem;
}
.head-data {
  background-color: #cfcccc;
}
.title {
  padding: 1rem;
}
</style>
